module.exports = __webpack_public_path__ + "static/media/Show.af9bd8a7.svg";